import type { Dispatch, SetStateAction } from 'react'
import { createContext } from 'react'

export type InventoryContextData = {
  isOpen?: boolean
  hasManagedInventory?: boolean
}

export type InventoryContextType = [
  InventoryContextData,
  Dispatch<SetStateAction<InventoryContextData>>,
]

export const InventoryContext = createContext<InventoryContextType>([
  {
    isOpen: false,
    hasManagedInventory: false,
  },
  () => {
    // noop
  },
])
